<template>
  <div style="margin-top: 1rem;">
    <b-button-toolbar
      key-nav
      aria-label="Toolbar with button groups"
      class="demo-inline-spacing"
    >
      <b-button-group
        size="sm"
        class="cbs-inline-spacing mb-1"
      >
        <b-button
          title="Создать новую заявку"
          :variant="hasEmptyRecord() ? 'outline-primary' : 'primary'"
          :disabled="hasEmptyRecord()"
          @click="createRequest()"
        >
          <feather-icon icon="PlusIcon" />&nbsp;Создать
        </b-button>
      </b-button-group>
      <b-button-group
        size="sm"
        class="cbs-inline-spacing mb-1"
      >
        <b-button
          title="Удалить заявку"
          :disabled="selected().length === 0"
          :variant="selected().length === 0 ? 'outline-danger' : 'danger'"
          @click="deleteRecords()"
        >
          <feather-icon icon="TrashIcon" />
          {{ t('Удалить') }} ({{ selected().length }})
        </b-button>
      </b-button-group>
    </b-button-toolbar>

    <cbs-collapse
      :trigger="dataReady"
      style="overflow: scroll; max-height: 70vh; min-height: 20rem;"
    >
      <table
        v-if="dataReady"
        class="table table-bordered"
      >
        <thead>
          <tr>
            <th
              :id="`firstcol_${uuid}`"
              class="stick-th1"
            >
              ID
            </th>
            <th class="stick-th">
              Вид ТРУ
            </th>
            <th
              :id="`secondcol_${uuid}`"
              class="stick-th2 stick-two"
            >
              Наименование ТРУ
            </th>
            <th class="stick-th">
              Раздел Бюджета
            </th>
            <th class="stick-th">
              Статья Бюджета
            </th>
            <th
              v-if="false"
              class="stick-th"
            >
              Статья КВ
            </th>
            <th class="stick-th">
              Ед изм
            </th>
            <th class="stick-th">
              Количество
            </th>
            <th class="stick-th">
              Валюта
            </th>
            <th class="stick-th">
              Цена
            </th>
            <th class="stick-th">
              Период инициации
            </th>
            <th class="stick-th">
              Тип закупа
            </th>
            <th class="stick-th">
              Условия оплаты
            </th>
            <th class="stick-th">
              НДС
            </th>
            <th class="stick-th">
              Контрагент
            </th>
            <th class="stick-th">
              Подразделение
            </th>
            <th class="stick-th">
              Автор
            </th>
            <th class="stick-th">
              Создано
            </th>
            <th class="stick-th2 stick-three">
              Сумма
            </th>
            <th
              v-for="(mn, idx) in monthnames"
              :key="'mn_' + idx"
              class="stick-th"
            >
              {{ mn + '-' + (baseYear - 2000) }}
            </th>
            <th
              rowspan="2"
              class="stick-th"
            >
              {{ baseYear }}
            </th>
            <th
              v-for="(yr, idx) in years"
              :key="'yr_' + idx"
              class="stick-th"
            >
              {{ baseYear + yr }}
            </th>
            <th
              rowspan="2"
              class="stick-th"
            >
              Всего
            </th>
          </tr>
          <tr>
            <th class="flt0 flt flt1">
              <cbs-budreq-filter
                :column="getColumn('id')"
                :condition="getCondition('id')"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyPurchaseType)"
                :condition="getCondition(keyPurchaseType)"
                :reference="refs['purchase_type']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt"
              :style="styleFlt2()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyInventoryName)"
                :condition="getCondition(keyInventoryName)"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyBudgetSection)"
                :condition="getCondition(keyBudgetSection)"
                :reference="refs['budget_section']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyPnl)"
                :condition="getCondition(keyPnl)"
                :reference="refs['pnlitem']"
                @apply="applyFilter()"
              />
            </th>
            <th
              v-if="false"
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyCapex)"
                :condition="getCondition(keyCapex)"
                :reference="refs['capex_item']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyMetric)"
                :condition="getCondition(keyMetric)"
                :reference="refs['metric']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyCurrency)"
                :condition="getCondition(keyCurrency)"
                :reference="refs['currency']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyPurchasePeriod)"
                :condition="getCondition(keyPurchasePeriod)"
                :reference="refs['purchase_period']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyFirm)"
                :condition="getCondition(keyFirm)"
                :reference="refs['firm']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyUnit)"
                :condition="getCondition(keyUnit)"
                :reference="refs['business_unit']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt0 flt2"
              :style="styleFlt3()"
            >
              <cbs-budreq-filter
                :column="getColumn(keyAuthorSid)"
                :condition="getCondition(keyAuthorSid)"
                :reference="refs['authorsid']"
                @apply="applyFilter()"
              />
            </th>
            <th
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              class="flt stick-three"
              :style="styleFlt4()"
            />
            <th
              v-for="(mn, idx) in monthnames"
              :key="'mnf_' + idx"
              class="flt2"
              :style="styleFlt3()"
            />
            <th
              v-for="(yr, idx) in years"
              :key="'yrf_' + idx"
              class="flt2"
              :style="styleFlt3()"
            />
          </tr>
        </thead>
        <tbody
          v-for="(rec, idx) in qryRequest.recordset.records"
          :key="idx"
        >
          <tr
            :key="'rec_' + rec.id.value + '_1'"
            style="padding: 0;"
          >
            <td
              rowspan="2"
              class="table-light stick-col1"
              style="padding: 0.5rem; text-align: center;"
              :style="rec.cbs_access === 'rw' ? 'cursor: pointer;' : ''"
              @click="selectRec(rec)"
            >
              <feather-icon
                v-if="rec.cbs_access === 'rw'"
                :icon="rec.selected ? 'CheckSquareIcon' : 'SquareIcon'"
              />
              <feather-icon
                v-if="rec.cbs_access === 'ro'"
                icon="LockIcon"
              />
              {{ rec.id.value }}
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyPurchaseType)"
                :prop-ref="refs['purchase_type']"
                key-mode="sid"
                style="text-align: center;"
                @updateCell="onUpdateCell(rec, 'purchase_type', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="table-light cell-val stick-col stick-two"
            >
              <cbs-budreq-cell
                align-left
                :record="rec"
                key-value="inventory_name"
                @edit="onEdit(rec, 'inventory_name', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyBudgetSection)"
                :prop-ref="refs['budget_section']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'budget_section', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-reference-picker3
                v-if="budgetSectionSid(rec.budget_section.value) === 'capex'"
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyCapex)"
                :prop-ref="refCapex(rec)"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'capex_item', $event)"
              />
              <cbs-reference-picker3
                v-else-if="budgetSectionSid(rec.budget_section.value) === 'cashflow'"
                :record="rec"
                :field="qryRequest.columns.find(c => c.entitysid === 'cashflow_item')"
                :prop-ref="refCashflow()"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'cashflow_item', $event)"
              />
              <cbs-reference-picker3
                v-else
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyPnl)"
                :prop-ref="refPnl(rec)"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'pnlitem', $event)"
              />
            </td>
            <td
              v-if="false"
              rowspan="2"
              class="cell-val"
            >
              <cbs-reference-picker3
                v-if="budgetSectionSid(rec.budget_section.value) === 'capex'"
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyCapex)"
                :prop-ref="refs['capex_item']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'capex_item', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyMetric)"
                :prop-ref="refs['metric']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'metric', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-budreq-cell
                :record="rec"
                key-value="qty"
                value-type="number"
                @edit="onEdit(rec, 'qty', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyCurrency)"
                :prop-ref="refs['currency']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'currency', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-budreq-cell
                :record="rec"
                key-value="pricecur"
                value-type="number"
                @edit="onEdit(rec, 'pricecur', $event)"
              />
            </td>
            <td rowspan="2">
              <cbs-budreq-cell
                :record="rec"
                key-value="purchase_date"
                value-type="date"
                @edit="onEdit(rec, 'purchase_date', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyPurchasePeriod)"
                :prop-ref="refs['purchase_period']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'purchase_period', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              <cbs-budreq-cell
                :record="rec"
                key-value="payment_terms"
                @edit="onEdit(rec, 'payment_terms', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.entitysid === 'vat_item')"
                :prop-ref="refs['vat_item']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'vat_item', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyFirm)"
                :prop-ref="refs['firm']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'firm', $event)"
              />
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              <cbs-reference-picker3
                v-if="isAdmin()"
                :record="rec"
                :field="qryRequest.columns.find(c => c.key === keyUnit)"
                :prop-ref="refs['business_unit']"
                key-mode="sid"
                @updateCell="onUpdateCell(rec, 'business_unit', $event)"
              />
              <span v-else>{{ rec.business_unit.title }}</span>
            </td>
            <td
              rowspan="2"
              class="cell-val"
            >
              {{ rec.authorsid.title }}
            </td>
            <td
              rowspan="2"
              class="cell-val"
              style="text-align: center;"
            >
              {{ rec.created.value }}
            </td>
            <td
              class="table-light stick-three"
              style="padding: 0 0.5rem 0 0.5rem;"
              :style="'position: sticky; left: ' + secondColWidth() + 'px; z-index: 1;'"
            >
              Начисление
            </td>
            <td
              v-for="mn in months"
              :id="mn < 12 ? `accr_mn_${rec.id.value}_${mn}_${uuid}` : ''"
              :key="'mn_' + mn"
              style="padding: 0 0.5rem 0 0.5rem;"
            >
              <cbs-budreq-cell
                :record="getSubRecord(rec, subObjSidAccrual, 'month', mn)"
                key-value="curamount"
                value-type="number"
                :access="rec.cbs_access"
                style="text-align: right;"
                @edit="onEditSub(getSubRecord(rec, subObjSidAccrual, 'month', mn), subObjSidAccrual, $event)"
              />
              <b-popover
                :target="`accr_mn_${rec.id.value}_${mn}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyTillYear(rec, mn, subObjSidAccrual)"
                  >
                    Скопировать до конца года
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td
              :id="`accr_baseyear_${rec.id.value}_${uuid}`"
              style="padding: 0 0.5rem 0 0.5rem; text-align: right;"
            >
              <b>{{ getBaseYearTotal(rec, subObjSidAccrual).toLocaleString() }}</b>
              <b-popover
                :target="`accr_baseyear_${rec.id.value}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyWithInflation(rec, subObjSidAccrual, 0)"
                  >
                    Увеличить на инфляцию
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td
              v-for="yr in years"
              :id="yr < years.length ? `accr_yr_${rec.id.value}_${yr}_${uuid}` : ''"
              :key="'yr_' + yr"
              style="padding: 0 0.5rem 0 0.5rem;"
            >
              <cbs-budreq-cell
                :record="getSubRecord(rec, subObjSidAccrual, 'year', yr)"
                key-value="curamount"
                value-type="number"
                :access="rec.cbs_access"
                style="text-align: right;"
                @edit="onEditSub(getSubRecord(rec, subObjSidAccrual, 'year', yr), subObjSidAccrual, $event)"
              />
              <b-popover
                :target="`accr_yr_${rec.id.value}_${yr}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    style="margin-bottom: 0.1rem;"
                    size="sm"
                    variant="outline-primary"
                    @click="copyYears(rec, yr, subObjSidAccrual)"
                  >
                    Скопировать по годам
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyWithInflation(rec, subObjSidAccrual, yr)"
                  >
                    Увеличить на инфляцию
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td style="padding: 0 0.5rem 0 0.5rem; text-align: right;">
              <b>{{ getTotal(rec, subObjSidAccrual).toLocaleString() }}</b>
            </td>
          </tr>
          <tr
            :key="'rec_' + rec.id.value + '_2'"
            style="padding: 0 1rem 0 1rem;"
          >
            <td
              class="table-light stick-three"
              style="padding: 0 0.5rem 0 0.5rem;"
              :style="'position: sticky; left: ' + secondColWidth() + 'px; z-index: 1;'"
            >
              Оплата
            </td>
            <td
              v-for="mn in months"
              :id="mn < 12 ? `paym_mn_${rec.id.value}_${mn}_${uuid}` : ''"
              :key="'mn_' + mn"
              style="padding: 0 0.5rem 0 0.5rem;"
            >
              <cbs-budreq-cell
                :record="getSubRecord(rec, subObjSidPayment, 'month', mn)"
                key-value="curamount"
                value-type="number"
                :access="rec.cbs_access"
                style="text-align: right;"
                @edit="onEditSub(getSubRecord(rec, subObjSidPayment, 'month', mn), subObjSidPayment, $event)"
              />
              <b-popover
                :target="`paym_mn_${rec.id.value}_${mn}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyTillYear(rec, mn, subObjSidPayment)"
                  >
                    Скопировать до конца года
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td
              :id="`paym_baseyear_${rec.id.value}_${uuid}`"
              style="padding: 0 0.5rem 0 0.5rem; text-align: right;"
            >
              <b>{{ getBaseYearTotal(rec, subObjSidPayment).toLocaleString() }}</b>
              <b-popover
                :target="`paym_baseyear_${rec.id.value}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyWithInflation(rec, subObjSidPayment, 0)"
                  >
                    Увеличить на инфляцию
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td
              v-for="yr in years"
              :id="yr < years.length ? `paym_yr_${rec.id.value}_${yr}_${uuid}` : ''"
              :key="'yr_' + yr"
              style="padding: 0 0.5rem 0 0.5rem;"
            >
              <cbs-budreq-cell
                :record="getSubRecord(rec, subObjSidPayment, 'year', yr)"
                key-value="curamount"
                value-type="number"
                :access="rec.cbs_access"
                style="text-align: right;"
                @edit="onEditSub(getSubRecord(rec, subObjSidPayment, 'year', yr), subObjSidPayment, $event)"
              />
              <b-popover
                :target="`paym_yr_${rec.id.value}_${yr}_${uuid}`"
                triggers="hover"
                :delay="delay"
              >
                <template #title />
                <div>
                  <b-button
                    style="margin-bottom: 0.1rem;"
                    size="sm"
                    variant="outline-primary"
                    @click="copyYears(rec, yr, subObjSidPayment)"
                  >
                    Скопировать по годам
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="copyWithInflation(rec, subObjSidPayment, yr)"
                  >
                    Увеличить на инфляцию
                  </b-button>
                </div>
              </b-popover>
            </td>
            <td style="padding: 0 0.5rem 0 0.5rem; text-align: right;">
              <b>{{ getTotal(rec, subObjSidPayment).toLocaleString() }}</b>
            </td>
          </tr>
          <tr
            v-if="false && rec.expanded"
            :key="'rec_' + rec.id.value + '_1'"
            style="margin: 0; padding: 0;"
          >
            <td
              colspan="12"
              style="margin: 0; padding: 0;"
            >
              <div style="margin-left: 1rem;">
                <cbs-collapse :trigger="rec.expanded">
                  <cbs-budreq-finance :budget-request="rec" />
                </cbs-collapse>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </cbs-collapse>

    <cbs-pagination
      v-if="qryRequest"
      :page-size="pageSize"
      :record-count="recordcount"
      :current-page="currentPage"
      @page-change="onChangePageNumber"
    />

    <cbs-debug
      v-if="isRoot"
      :context="this"
    />
  </div>
</template>

<script>
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import useCubus from '@/cubus/services/useCubus'
import CbsCollapse from '@/cubus/components/collapsible/CbsCollapse.vue'
import CbsBudreqFinance from '@/cubus/components/cbs-form/custom-forms/budget-request/CbsBudreqFinance.vue'
import CbsPagination from '@/cubus/components/pagination/CbsPagination.vue'
import {
  BButton, BButtonGroup, BButtonToolbar, BPopover, VBPopover, VBTooltip,
} from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import CbsBudreqCell from '@/cubus/components/cbs-form/custom-forms/budget-request/CbsBudreqCell.vue'
import CbsReferencePicker3 from '@/cubus/components/reference/CbsReferencePicker3.vue'
import CbsBudreqFilter from '@/cubus/components/cbs-form/custom-forms/budget-request/CbsBudreqFilter.vue'

export default {
  name: 'CbsBudreqTable',
  components: {
    CbsBudreqFilter,
    CbsReferencePicker3,
    CbsBudreqCell,
    CbsPagination,
    CbsCollapse,
    CbsDebug,
    CbsBudreqFinance,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BPopover,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-popover': VBPopover,
  },
  props: {
    scenario: {
      type: Object,
      default: null,
    },
    keyScenario: {
      type: String,
      default: null,
    },
    keyBaseYear: {
      type: String,
      default: null,
    },
    qryAccess: {
      type: Object,
      default: null,
    },
    roValue: {
      type: Number,
      default: null,
    },
    rwValue: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const { t } = useI18nUtils()
    const session = useCubus.getSession()
    const cfg = {
      objSid_budgetSection: 'budget_section',
      objSid_request: 'cube_budget_request',
      objSid_pnl: 'refpnl',
      objSid_capex: 'refcapex',
      entSid_access: 'indicatoraccess',
      entSid_budgetSection: 'budget_section',
      entSid_pnl: 'pnlitem',
      entSid_capex: 'capex_item',
      entSid_role: 'role',
      filter_notDel: {
        isactive: true,
        node: {
          isactive: true,
          oper: { sid: 'and' },
          nodes: [],
          conds: [
            {
              isactive: true,
              oper: { sid: 'equal' },
              args: [
                { type: { sid: 'entitysid' }, value: 'del' },
                { type: { sid: 'value' }, value: false },
              ],
            },
          ],
        },
      },
      orderby_code: {
        isActive: true,
        sorts: [
          {
            isActive: true,
            oper: { sid: 'asc' },
            entity: { sid: 'code' },
          },
        ],
      },
    }
    return {
      t, // i18n
      session,
      cfg,
      isRoot: useCubus.isRoot(),
    }
  },
  data() {
    return {
      uuid: null,
      // firstColunm: null,
      // secondColumn: null,
      objRequest: null,
      objBudgetSection: null,
      qryRequest: null,
      qryBudgetSection: null,
      keyPurchaseType: null,
      keyInventoryName: null,
      // keySupplierInventoryName: null,
      keyBudgetSection: null,
      keyPnl: null,
      keyCashflow: null,
      keyCapex: null,
      keyMetric: null,
      keyQuantity: null,
      keyCurrency: null,
      keyPrice: null,
      keyPurchaseDate: null,
      keyPurchasePeriod: null,
      keyPaymentTerms: null,
      keyAuthorSid: null,
      keyCreated: null,
      keyUnit: null,
      keyFirm: null,
      keyVat: null,
      pageSize: 10,
      currentPage: 1,
      recordcount: 0,
      obj: null,
      monthnames: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      years: [1, 2, 3, 4],
      baseYear: null,
      refBudgetSection: null,
      refs: {},
      menuVisible: false,
      subObjSidAccrual: 'budget_request_accrual',
      subObjSidPayment: 'budget_request_payment',
      keyAccess: null,
      keyRole: null,
      filter: {
        isactive: true,
        node: {
          isactive: true,
          oper: { sid: 'and' },
          nodes: [
            {
              isactive: true,
              oper: { sid: 'and', name: 'AND' },
              nodes: [],
              conds: [],
            },
          ],
          conds: [
            {
              isactive: true,
              oper: { sid: 'equal' },
              args: [
                { type: { sid: 'entitysid' }, value: 'del' },
                { type: { sid: 'value' }, value: false },
              ],
            },
            {
              isactive: true,
              oper: { sid: 'equal' },
              args: [
                { type: { sid: 'entitysid' }, value: 'scenario' },
                { type: { sid: 'value' }, value: this.scenario[this.keyScenario].value },
              ],
            },
          ],
        },
      },
      dataReady: false,
      delay: { show: 1000, hide: 50 },
      qryRefIndicator: null,
      qryIndicator: null,
    }
  },
  computed: {
    locale() {
      return useCubus.locale(this.$i18n.locale)
    },
  },
  created() {
    this.uuid = useCubus.guid()
    this.init()
  },
  methods: {
    init() {
      this.keyAccess = this.qryAccess.columns.find(c => c.entitysid === this.cfg.entSid_access).key
      this.keyRole = this.qryAccess.columns.find(c => c.entitysid === this.cfg.entSid_role).key
      this.baseYear = this.scenario[this.keyBaseYear].value
      this.loadObjBudgetSection()
    },
    async loadObjBudgetSection() {
      this.objBudgetSection = await useCubus.loadObject(this, { objectsid: this.cfg.objSid_budgetSection })
      const params = {
        keymode: 'sid',
        objectsid: this.cfg.objSid_budgetSection,
        filter: this.cfg.filter_notDel,
        orderby: this.cfg.orderby_code,
        pageSize: useCubus.LOAD_ALL,
      }
      this.qryBudgetSection = await useCubus.loadQuery(this, params)
      this.objRequest = await useCubus.loadObject(this, { objectsid: this.cfg.objSid_request })
      this.refBudgetSection = await this.loadRef(this.cfg.entSid_budgetSection)
      this.qryRefIndicator = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'budgetindicator',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
            ],
          },
        },
      })
      this.qryIndicator = await useCubus.loadQuery(this, {
        keymode: 'sid',
        objectsid: 'cube_indicator_product_value',
        filter: {
          isactive: true,
          node: {
            isactive: true,
            oper: { sid: 'and' },
            nodes: [],
            conds: [
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'del' },
                  { type: { sid: 'value' }, value: false },
                ],
              },
              {
                isactive: true,
                oper: { sid: 'equal' },
                args: [
                  { type: { sid: 'entitysid' }, value: 'scenario' },
                  { type: { sid: 'value' }, value: this.scenario[this.keyScenario].value },
                ],
              },
            ],
          },
        },
      })
      await this.loadQryRequest('init')
    },
    async loadQryRequest(caller) {
      const params = {
        keymode: 'sid',
        withsubrecords: true,
        objectsid: this.cfg.objSid_request,
        filter: this.filter,
        pageSize: this.pageSize,
        offset: this.pageSize * (this.currentPage - 1),
      }
      this.qryRequest = await useCubus.loadQuery(this, params)
      if (this.qryRequest && caller === 'init') {
        this.initQryRequest()
        await this.initRefs()
        this.dataReady = true
        /*
        this.$nextTick(() => {
          this.firstColunm = document.getElementById(`firstcol_${this.uuid}`)
          this.secondColunm = document.getElementById(`secondcol_${this.uuid}`)
          this.stickSecondCol()
        })
        */
      }
      this.$nextTick(() => {
        this.firstColunm = document.getElementById(`firstcol_${this.uuid}`)
        this.secondColunm = document.getElementById(`secondcol_${this.uuid}`)
        this.stickSecondCol()
      })
      this.qryRequest.recordset.records.forEach(r => this.$set(r, 'cbs_access', this.accessSid(r)))
    },
    async loadRef(entitysid) {
      if (entitysid === this.cfg.entSid_budgetSection && this.qryBudgetSection) {
        this.initRefBudgetSection()
      } else if (entitysid === this.cfg.entSid_pnl) {
        this.initRefPnl()
      } else if (entitysid === this.cfg.entSid_capex) {
        this.initRefCapex()
      } else {
        const ref = await useCubus.loadRef(this, { entitysid })
        if (ref) {
          this.$set(this.refs, entitysid, ref)
        }
      }
    },
    initQryRequest() {
      const qry = this.qryRequest
      this.keyPurchaseType = qry.columns.find(c => c.entitysid === 'purchase_type').key
      this.keyInventoryName = qry.columns.find(c => c.entitysid === 'inventory_name').key
      this.keyBudgetSection = qry.columns.find(c => c.entitysid === 'budget_section').key
      this.keyPnl = qry.columns.find(c => c.entitysid === this.cfg.entSid_pnl).key
      this.keyCashflow = qry.columns.find(c => c.entitysid === 'cashflow_item').key
      this.keyCapex = qry.columns.find(c => c.entitysid === 'capex_item').key
      this.keyMetric = qry.columns.find(c => c.entitysid === 'metric').key
      this.keyQuantity = qry.columns.find(c => c.entitysid === 'qty').key
      this.keyCurrency = qry.columns.find(c => c.entitysid === 'currency').key
      this.keyPrice = qry.columns.find(c => c.entitysid === 'pricecur').key
      this.keyPurchaseDate = qry.columns.find(c => c.entitysid === 'purchase_date').key
      this.keyPurchasePeriod = qry.columns.find(c => c.entitysid === 'purchase_period').key
      this.keyPaymentTerms = qry.columns.find(c => c.entitysid === 'payment_terms').key
      this.keyAuthorSid = qry.columns.find(c => c.entitysid === 'authorsid').key
      this.keyCreated = qry.columns.find(c => c.entitysid === 'created').key
      this.keyUnit = qry.columns.find(c => c.entitysid === 'business_unit').key
      this.keyFirm = qry.columns.find(c => c.entitysid === 'firm').key
      this.keyVat = qry.columns.find(c => c.entitysid === 'vat_item').key
      this.recordcount = qry.recordcount
    },
    stickSecondCol() {
      const offset = document.getElementById(`firstcol_${this.uuid}`).offsetWidth
      const offset2 = document.getElementById(`secondcol_${this.uuid}`).offsetWidth
      const offset3 = document.getElementById(`firstcol_${this.uuid}`).offsetHeight
      // console.log('offset', offset)
      document.querySelectorAll('.stick-two').forEach(cell => {
        const c = cell; c.style.left = `${offset}px`
      })
      document.querySelectorAll('.stick-three').forEach(cell => {
        const c = cell; c.style.left = `${offset + offset2}px`
      })
      document.querySelectorAll('.flt0').forEach(cell => {
        const c = cell; c.style.top = `${offset3}px`
      })
    },
    initRefs() {
      this.qryRequest.columns.filter(c => c.datatype === 'ref' || c.datatype === 'refsid').forEach(c => {
        this.loadRef(c.entitysid)
      })
    },
    initRefBudgetSection() {
      // console.log('initRefBudgetSection', this.qryBudgetSection)
      const ref = this.qryBudgetSection.recordset.records.map(rec => (
        {
          title: `${rec.code.value}. ${rec.name.value}`,
          value: rec.id.value,
          sid: rec.sid.value,
          disabled: rec.isfolder.value,
          code: rec.code.value,
        }
      ))
      if (ref) this.$set(this.refs, this.cfg.entSid_budgetSection, ref)
    },
    async initRefPnl() {
      const params = {
        objectsid: this.cfg.objSid_pnl,
        filter: this.cfg.filter_notDel,
        orderby: this.cfg.orderby_code,
        keymode: 'sid',
      }
      const qry = await useCubus.loadQuery(this, params)
      if (qry) {
        const ref = qry.recordset.records.map(rec => (
          {
            title: `${rec.code.value}. ${rec.name.value}`,
            value: rec.id.value,
            sid: rec.sid.value,
            disabled: rec.isfolder.value,
            code: rec.code.value,
            budget_section: rec.budget_section.value,
          }
        ))
        this.$set(this.refs, this.cfg.entSid_pnl, ref)
      }
    },
    async initRefCapex() {
      const params = {
        objectsid: this.cfg.objSid_capex,
        filter: this.cfg.filter_notDel,
        orderby: this.cfg.orderby_code,
        keymode: 'sid',
      }
      const qry = await useCubus.loadQuery(this, params)
      if (qry) {
        const ref = qry.recordset.records.map(rec => (
          {
            title: `${rec.code.value}. ${rec.name.value}`,
            value: rec.id.value,
            sid: rec.sid.value,
            disabled: rec.isfolder.value,
            code: rec.code.value,
            budget_section: rec.budget_section.value,
          }
        ))
        this.$set(this.refs, this.cfg.entSid_capex, ref)
      }
    },
    firstColWidth() {
      if (this.firstColunm) return this.firstColunm.offsetWidth
      return 0
    },
    secondColWidth() {
      if (this.secondColunm) return this.firstColunm.offsetWidth + this.secondColunm.offsetWidth
      return 0
    },
    filterRequest() {
      return {
        isactive: true,
        node: {
          isactive: true,
          oper: { sid: 'and' },
          nodes: [],
          conds: [
            {
              isactive: true,
              oper: { sid: 'equal' },
              args: [
                { type: { sid: 'entitysid' }, value: 'del' },
                { type: { sid: 'value' }, value: false },
              ],
            },
            {
              isactive: true,
              oper: { sid: 'equal' },
              args: [
                { type: { sid: 'entitysid' }, value: 'scenario' },
                { type: { sid: 'value' }, value: this.scenario[this.keyScenario].value },
              ],
            },
          ],
        },
      }
    },
    budgetSectionSid(id) {
      if (!id) return null
      const section = this.qryBudgetSection.recordset.records.find(r => r.id.value === id)
      if (section.code.value.startsWith('3')) return 'capex'
      if (section.sid.value === 'cashflow') return 'cashflow'
      return 'pnl'
    },
    onChangePageNumber(page) {
      // console.log('onChangePageNumber', page)
      this.currentPage = page
      this.loadQryRequest('pager')
    },
    stick() {
      const c = document.getElementById(`firstcol_${this.uuid}`)
      return c ? c.offsetWidth : 0
    },
    stick2() {
      const c = document.getElementById(`secondcol_${this.uuid}`)
      return c ? this.stick() + c.offsetWidth : 0
    },
    stick_h1() {
      const c = document.getElementById(`firstcol_${this.uuid}`)
      return c ? c.offsetHeight : 0
    },
    getSubRecord(parentRec, subObjectSid, periodName, pariodNum) {
      const strDt = this.getStrDate(periodName, pariodNum)
      const keyDate = this.keyDate(subObjectSid)
      const subRec = parentRec.sub_recordsets[subObjectSid].records.find(r => r.date.value.startsWith(strDt))
      if (subRec) return subRec
      const newRec = this.getNewSubRecord(parentRec.sid.value, subObjectSid, keyDate, strDt)
      parentRec.sub_recordsets[subObjectSid].records.push(newRec)
      return newRec
    },
    keyDate(subObjectSid) {
      const subColumns = this.qryRequest.subcolumns[subObjectSid]
      if (!subColumns) {
        // useCubus.toastError(this, `SubColumns for ${subObjectSid} not found`)
        return 'date'
      }
      const col = subColumns.columns.find(c => c.entitysid === 'date')
      if (col) return col.key
      return 'date'
    },
    keyAmountCur(subObjectSid) {
      const col = this.qryRequest.subcolumns[subObjectSid].columns.find(c => c.entitysid === 'curamount')
      if (col) return col.key
      return 'curamount'
    },
    getStrDate(periodName, periodNum) {
      if (periodName === 'month') {
        // return `01.${periodNum < 10 ? `0${periodNum}` : periodNum}.${this.baseYear}`
        return `${this.baseYear}-${periodNum < 10 ? `0${periodNum}` : periodNum}-01`
      }
      return `${this.baseYear + periodNum}-01-01`
    },
    getNewSubRecord(parentRecSid, subObjectSid, keyDate, strDate) {
      const res = {}
      this.qryRequest.subcolumns[subObjectSid].columns.forEach(c => {
        res[c.entitysid] = c.default
      })
      res.del.value = false
      res.ownersid.value = parentRecSid
      res.date.value = strDate
      res.created.value = useCubus.dateToString(new Date())
      return JSON.parse(JSON.stringify(res))
    },
    subObject(sid) {
      return this.objRequest.children.find(c => c.object.sid === sid)
    },
    subColumns(sid) {
      return this.qryRequest.subcolumns[sid].columns
    },
    onEditSub(rec, subObjectSid, newValue) {
      const r = rec
      r.curamount.value = newValue
      r.curamount.status = 'changed'
      this.saveSubRecord(this.subObject(subObjectSid), rec)
    },
    async saveSubRecord(subObject, record) {
      try {
        const saved = await useCubus.saveRecord(this, { keymode: 'sid', objectid: subObject.object.id, record })
        this.afterSaveSub(record, saved, subObject)
      } catch (e) { console.error(e) }
    },
    afterSaveSub(initRec, savedRec, subObject) {
      const s = savedRec
      const i = initRec
      s.status = 'saved'
      this.subColumns(subObject.object.sid).forEach(fld => {
        if (fld.key !== 'actions') {
          i[fld.entitysid].value = savedRec[fld.entitysid].value
          i[fld.entitysid].title = savedRec[fld.entitysid].title
        }
      })
      i.status = 'saved'
    },
    onEdit(rec, key, newValue) {
      const r = rec
      r[key].value = newValue
      r[key].status = 'changed'
      this.saveRecord(rec)
    },
    async saveRecord(record) {
      try {
        const saved = await useCubus.saveRecord(this, { keymode: 'sid', objectid: this.objRequest.object.id, record })
        this.afterSave(record, saved)
      } catch (e) { console.error(e) }
    },
    afterSave(initRec, savedRec) {
      // eslint-disable-next-line no-param-reassign
      console.log('initRec', initRec)
      const i = initRec
      const s = savedRec; s.status = 'saved'
      this.qryRequest.columns.forEach(fld => {
        // console.log(`fld : ${fld.key}, ${fld.entitysid}`)
        if (fld.key !== 'actions') {
          i[fld.entitysid].value = savedRec[fld.entitysid].value
          i[fld.entitysid].title = savedRec[fld.entitysid].title
        }
      })
      this.objRequest.children.forEach(child => {
        // console.log(child.object.sid)
        initRec.sub_recordsets[child.object.sid].records.forEach(subrec => { const sr = subrec; sr.ownersid.value = savedRec.sid.value })
      })
      i.status = 'saved'
    },
    createRequest() {
      const rec = this.getNewRecord()
      this.qryRequest.recordset.records.unshift(rec)
    },
    getNewRecord() {
      const n = {}
      this.qryRequest.columns.forEach(fld => {
        if (fld.default) {
          n[fld.entitysid] = {}
          n[fld.entitysid].value = fld.default.value
          n[fld.entitysid].title = fld.default.title
        }
      })
      n.scenario.value = this.scenario[this.keyScenario].value
      n.scenario.title = this.scenario[this.keyScenario].title
      n.authorsid.value = this.session.user.sid
      n.authorsid.title = this.session.user.name
      n.created.value = useCubus.dateToString(new Date())
      n.cbs_access = 'rw'
      n.sub_recordsets = {}
      this.objRequest.children.forEach(c => {
        n.sub_recordsets[c.object.sid] = { records: [] }
      })
      return JSON.parse(JSON.stringify(n))
    },
    selectRec(rec) {
      if (rec.cbs_access === 'ro') return
      if (!rec.selected) this.$set(rec, 'selected', true)
      else { const r = rec; r.selected = !rec.selected }
    },
    selected() {
      if (!this.qryRequest) return []
      return this.qryRequest.recordset.records.filter(r => r.selected)
    },
    deleteRecords() {
      // console.log('deleteRecs', this.selected())
      this.qryRequest.recordset.records.filter(r => r.selected).forEach(r => {
        this.deleteSubRecords(r)
        if (r.sid.value) {
          this.deleteRecord(this.objRequest.object.id, r, this.qryRequest.recordset.records)
        } else {
          this.qryRequest.recordset.records.splice(this.qryRequest.recordset.records.indexOf(r), 1)
        }
      })
    },
    async deleteRecord(objectid, record, records) {
      try {
        await useCubus.deleteRecordByParams({ objectid, record })
        records.splice(this.qryRequest.recordset.records.indexOf(record), 1)
      } catch (e) { console.error(e) }
    },
    deleteSubRecords(record) {
      this.objRequest.children.forEach(c => {
        record.sub_recordsets[c.object.sid].records.forEach(r => {
          if (r.id.value) this.deleteRecord(c.object.id, r, record.sub_recordsets[c.object.sid].records)
        })
      })
    },
    onUpdateCell(rec, key, val) {
      const r = rec
      r[key].value = val.value
      r[key].title = val.title
      r[key].status = 'changed'
      this.saveRecord(rec)
    },
    hasEmptyRecord() {
      if (!this.qryRequest) return true
      return this.qryRequest.recordset.records.some(r => r.id.value === null)
    },
    isAdmin() {
      return this.session.user.roles.some(r => r.sid === 'admin')
    },
    accessSid(rec) {
      const unitid = rec.business_unit.value
      const accessRecord = this.qryAccess.recordset.records
        .some(acc => acc[this.keyUnit].value === unitid
            && acc[this.keyAccess].value === this.rwValue
            && this.session.user.roles.some(role => role.id === acc[this.keyRole].value))
      if (accessRecord || this.isAdmin()) return 'rw'
      return 'ro'
    },
    styleStick2() {
      return {
        left: `${this.stick()}px`,
      }
    },
    styleFlt2() {
      return {
        left: `${this.stick()}px`,
        top: `${this.stick_h1()}px`,
      }
    },
    styleFlt3() {
      return {
        top: `${this.stick_h1()}px`,
      }
    },
    styleFlt4() {
      return {
        left: `${this.stick2()}px`,
        top: `${this.stick_h1()}px`,
      }
    },
    getCondition(key) {
      const col = this.qryRequest.columns.find(c => c.key === key)
      if (!col) return null
      const cond = this.filter.node.nodes[0].conds.find(c => c.args[0].value === col.entityid)
      if (cond) return cond
      const newCond = this.getNewCondition(col)
      this.filter.node.nodes[0].conds.push(newCond)
      return newCond
    },
    getNewCondition(col) {
      const operSid = col.datatype === 'string' ? 'contain' : 'equal'
      return {
        isactive: false,
        oper: { sid: operSid },
        args: [
          { type: { sid: 'entity' }, value: col.entityid },
          { type: { sid: 'value' }, value: null },
        ],
      }
    },
    applyFilter() {
      this.loadQryRequest('filter')
    },
    getColumn(key) {
      return this.qryRequest.columns.find(c => c.key === key)
    },
    refPnl(rec) {
      // console.log('refPnl', rec)
      if (!rec) return null
      const budgetSectionId = rec.budget_section.value
      // console.log('budgetSectionId', budgetSectionId)
      // console.log('ref pnl', this.refs.pnlitem)
      if (this.refs.pnlitem) {
        return this.refs.pnlitem.filter(r => r.budget_section === budgetSectionId)
      }
      return []
    },
    refCapex(rec) {
      if (!rec) return null
      const budgetSectionId = rec.budget_section.value
      if (this.refs.capex_item) {
        return this.refs.capex_item.filter(r => r.budget_section === budgetSectionId)
      }
      return []
    },
    refCashflow() {
      if (this.refs.cashflow_item) {
        return this.refs.cashflow_item
      }
      return []
    },
    getBaseYearTotal(rec, subObjectSid) {
      return rec.sub_recordsets[subObjectSid].records.filter(r => r.date.value.startsWith(`${this.baseYear}-`)).reduce((acc, r) => acc + (r.curamount.value || 0), 0)
    },
    getTotal(rec, subObjectSid) {
      return rec.sub_recordsets[subObjectSid].records.reduce((acc, r) => acc + (r.curamount.value || 0), 0)
    },
    copyTillYear(rec, mnth, subObjectSid) {
      const srcValue = this.getSubRecord(rec, subObjectSid, 'month', mnth).curamount.value
      let i = mnth + 1
      while (i <= 12) {
        this.onEditSub(this.getSubRecord(rec, subObjectSid, 'month', i), subObjectSid, srcValue)
        i += 1
      }
    },
    copyYears(rec, yr, subObjectSid) {
      const srcValue = this.getSubRecord(rec, subObjectSid, 'year', yr).curamount.value
      let i = yr + 1
      while (i <= this.years.length) {
        this.onEditSub(this.getSubRecord(rec, subObjectSid, 'year', i), subObjectSid, srcValue)
        i += 1
      }
    },
    copyWithInflation(rec, subObjectSid, yr) {
      let crsValue = yr === 0 ? this.getBaseYearTotal(rec, subObjectSid) : this.getSubRecord(rec, subObjectSid, 'year', yr).curamount.value
      let i = yr + 1
      while (i <= this.years.length) {
        crsValue *= (1 + this.getInflationRate('year', i))
        this.onEditSub(this.getSubRecord(rec, subObjectSid, 'year', i), subObjectSid, crsValue)
        i += 1
      }
    },
    getInflationRate(periodName, periodNum) {
      const dt = this.getStrDate(periodName, periodNum)
      const rec = this.qryIndicator.recordset.records.find(r => r.date.value.startsWith(dt) && this.getIndicator(r.budget_indicator.value).sid.value === 'inflation_rate')
      if (rec) return rec.indicator_value.value
      return 0
    },
    getIndicator(id) {
      return this.qryRefIndicator.recordset.records.find(r => r.id.value === id)
    },
  },
}
</script>

<style scoped>
.stick-th1 {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
.stick-th2 {
  position: sticky;
  top: 0;
  z-index: 3;
}
.stick-th {
  position: sticky;
  top: 0;
  z-index: 2;
}
.stick-col1 {
  position: sticky;
  left: 0;
  z-index: 1;
}
.stick-col {
  position: sticky;
  z-index: 1;
}
.cell-val {
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
}
.cell-ref {
  padding: 0.3rem 0.1rem 0.3rem 0.1rem;
  border-left: none;
  border-right: none;
}
.ref-left {
  border-left: none;
}
.ref-right {
  border-right: none;
}
.cell {
  padding: 0.2rem 0.5rem 0.2rem 0.5rem;
}
.flt0 {
  text-transform: none;
  font-weight: normal;
}
.flt1 {
  left: 0;
}
.flt {
  padding: 0.2rem;
  text-align: center;
  position: sticky;
  z-index: 3;
}
.flt2 {
  padding: 0.2rem;
  text-align: center;
  position: sticky;
  z-index: 2;
}
</style>
